import BaseService from "../BaseService";
import { API_BASE_URL_ENV } from "../../jsx/common/common";
import http from "../HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/requests/vacation";

export default class VacationRequestService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	changeStatus(id, status) {
		return http.post(`${apiEndpoint}/${id}/status`, { status });
	}
}
